import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  pickupAddress: [],
  pickupAddressCount: null,
  billingAddress: [],
  billingAddressCount: null,
};

const cartAddressManagementSlice = createSlice({
  name: "cartAddressManagement",
  initialState,
  reducers: {
    fetchPickupAddress(state, action) {
      state.loading = true;
      state.pickupAddress = [];
    },
    fetchPickupAddressSuccess(state, action) {
      state.loading = false;
      state.pickupAddress = action.payload.data.document;
      state.pickupAddressCount = action.payload.count;
    },
    fetchPickupAddressFailure(state, action) {
      state.loading = false;
    },
    fetchBillingAddress(state, action) {
      state.loading = true;
      state.billingAddress = [];
    },
    fetchBillingAddressSuccess(state, action) {
      state.loading = false;
      state.billingAddress = action.payload.data.document;
      state.billingAddressCount = action.payload.count;
    },
    fetchBillingAddressFailure(state, action) {
      state.loading = false;
    },
    initializeState(state, action) {
      state.loading = false;
      state.error = null;
      state.pickupAddress = [];
      state.pickupAddressCount = null;
      state.billingAddress = [];
      state.billingAddressCount = null;
    },
  },
});

export const { actions, reducer, name: sliceKey } = cartAddressManagementSlice;
